import type { GenerateSocialImageResponse, SocialImageOrientation } from '@pulsify/shared/dto'
import { api, unwrap } from '~/shared/lib/rpc'

export const imageApi = {
  async generate(
    businessId: string,
    prompt: string,
    orientation: SocialImageOrientation,
    purpose?: 'event-cover',
  ): Promise<GenerateSocialImageResponse> {
    const res = await api.api.businesses[':businessId']['ai-studio'].image.$post({
      param: { businessId },
      json: { prompt, orientation, purpose },
    })
    return unwrap<GenerateSocialImageResponse>(res)
  },
}
